<script lang="ts">
	import { format } from 'svelte-i18n';
	import { devices } from 'src/stores';
	import { devices_status } from 'src/stores/device-runtime/status';
	import DashEnvironmentWidgetCard from 'src/components/Dashboards/DashWidgets/Components/DashEnvironmentWidgetCard.svelte';
	import {
		getDevicesWithEnvironmentReadings,
		getEnvironmentReadingForDevice,
	} from 'src/components/Dashboards/dash-environment-helpers';
	import { energyMonitoringDataMode } from 'src/components/EnergyMonitoring/helpers/store';
	import EmWidgetShell from '../EmWidgetShell.svelte';
	import EmWidgetState from '../EmWidgetState.svelte';
	import { ENERGY_ADD_DEVICE_HREF } from '../helpers/energy_widget_state_helpers';

	export let horizontal = false;
	export let staticPreview = false;

	const selectEnvironmentDevice = (
		environmentDevices: ReturnType<typeof getDevicesWithEnvironmentReadings>,
		statusRevision: unknown,
	) => {
		void statusRevision;
		return (
			environmentDevices.find((device) => getEnvironmentReadingForDevice(device).online) ??
			environmentDevices[0]
		);
	};

	$: environmentDevices = getDevicesWithEnvironmentReadings(Object.values($devices));
	$: selectedDevice = selectEnvironmentDevice(environmentDevices, $devices_status);
	$: cards = horizontal
		? environmentDevices.map((device, position) => ({ id: device.id, position }))
		: selectedDevice
			? [{ id: selectedDevice.id, position: 0 }]
			: [];
	$: usePreviewData = staticPreview || $energyMonitoringDataMode === 'demo';
</script>

<EmWidgetShell
	widgetClass="energy-widget-environment"
	title={$format('energy_monitoring_environment_title', { default: 'Environment' })}
	infoText={$format('energy_monitoring_environment_info', {
		default: 'Temperature and humidity readings from your environmental sensors.',
	})}
>
	{#if usePreviewData || cards.length}
		<DashEnvironmentWidgetCard {cards} staticPreview={usePreviewData} {horizontal} />
	{:else}
		<EmWidgetState
			kind="setup"
			message={$format('energy_monitoring_environment_setup', {
				default: 'Add a temperature or humidity sensor to see environmental conditions.',
			})}
			minHeight="160px"
			actionHref={ENERGY_ADD_DEVICE_HREF}
			actionLabel={$format('button_add_device', { default: 'Add device' })}
		/>
	{/if}
</EmWidgetShell>
